import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { is, update, remove } from 'ramda'
import interact from 'interactjs'

class Box extends Component {
  static boxStyle = (coordinate) => {
    const {
      x, y, width, height,
    } = coordinate

    return {
      background: 'rgba(0,0,0,0)',
      display: 'inline-block',
      position: 'absolute',
      width,
      height,
      top: y,
      left: x,
      borderStyle: 'solid',
      borderColor: 'black',
      backgroundColor: 'inherit'
    }
  }

  componentDidMount() {
    interact(this.box)
      .draggable({})
      .resizable({
        edges: {
          left: true, right: true, bottom: true, top: true,
        },
        margin: 3,

      })
      .on('dragmove', this.handleDragMove)
      .on('resizemove', this.handleResizeMove)
      .on('click', this.handleClick)
  }

  handleResizeMove = (e) => {
    const {
      index,
      coordinate,
      coordinate: { x, y },
      coordinates,
      onResize,
      onChange,
      zoom
    } = this.props
    const { width, height } = e.rect
    const { left, top } = e.deltaRect
    const nextCoordinate = {
      ...coordinate, x: x + (left / zoom), y: y + (top / zoom), width: width / zoom, height: height / zoom,
    }
    const nextCoordinates = update(index, nextCoordinate)(coordinates)
    if (is(Function, onResize)) {
      onResize(nextCoordinate, index, nextCoordinates)
    }
    if (is(Function, onChange)) {
      onChange(nextCoordinate, index, nextCoordinates)
    }
  }

  handleDragMove = (e) => {
    const {
      index,
      coordinate,
      coordinate: { x, y },
      coordinates,
      onDrag,
      onChange,
      zoom
    } = this.props
    const { dx, dy } = e
    const nextCoordinate = { ...coordinate, x: x + (dx / zoom), y: y + (dy / zoom) }
    const nextCoordinates = update(index, nextCoordinate)(coordinates)
    if (is(Function, onDrag)) {
      onDrag(nextCoordinate, index, nextCoordinates)
    }

    if (is(Function, onChange)) {
      onChange(nextCoordinate, index, nextCoordinates)
    }
  }

  handleDelete = () => {
    const {
      index,
      coordinate,
      onDelete,
      coordinates,
    } = this.props
    const nextCoordinates = remove(index, 1)(coordinates)
    if (is(Function, onDelete)) {
      onDelete(coordinate, index, nextCoordinates)
    }
  }

  handleClick = () => {
    const {
      index,
      coordinate,
      coordinate: { x, y },
      coordinates,
      onClick
    } = this.props

    const nextCoordinate = { ...coordinate, x: x, y: y }
    const nextCoordinates = update(index, nextCoordinate)(coordinates)
    document.getElementById('bounding-dropdown_' + (index)).focus()
    if (is(Function, onClick)) {
      onClick(coordinate, index, nextCoordinates)
    }
  }

  componentWillUnmount() {
    interact(this.box)
      .unset()
  }

  render() {
    const { coordinate, index } = this.props
    return (
      <div className="tooltip"
        style={Box.boxStyle(coordinate)}
        ref={box => this.box = box}
      >
        <div tabIndex="5" id={"box_" + index} className="boundingbox">
          <div style={{ paddingTop: '5px', paddingLeft: '5px' }}>
          </div>
        </div>
      </div>
    )
  }
}

export const coordinateType = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
})

Box.propTypes = {
  coordinate: coordinateType.isRequired,
  index: PropTypes.number.isRequired,
  onResize: PropTypes.func,
  onDrag: PropTypes.func,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  coordinates: PropTypes.array
}

export default Box

